import APIClient from '../services/APIClient';

export const TELEMETRY_ENDPOINT = '/telemetry/devices/measures';
export const TELEMETRY_MEASUREMENTS_ENDPOINT = `${TELEMETRY_ENDPOINT}/measurements`;
export const TELEMETRY_MEASUREMENTS_EXPORT_ENDPOINT = `${TELEMETRY_MEASUREMENTS_ENDPOINT}/export`;
export const TELEMETRY_DE_ENDPOINT = `${TELEMETRY_ENDPOINT}/delivered-energy`;

export class TLM {
  getChargerMetrics = (params) => APIClient.post(TELEMETRY_MEASUREMENTS_ENDPOINT, params);

  getSnapshot = (params) => APIClient.post(`${TELEMETRY_MEASUREMENTS_ENDPOINT}/latest`, params);

  getTelemetry = (params) => APIClient.post(`${TELEMETRY_MEASUREMENTS_ENDPOINT}/timeseries`, params);

  getTelemetryTotal = (params) => APIClient.post(`${TELEMETRY_MEASUREMENTS_ENDPOINT}/timeseries/total`, params);

  getDeliveredEnergy = (params) => APIClient.post(`${TELEMETRY_DE_ENDPOINT}/measurements/timeseries`, params);
}

export default new TLM();
